import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props {
  className?: string;
}

export function AddAnnouncementButton(props: Props) {
  const push = useNavigate();
  const { t } = useTranslation();
  const { className } = props;

  return (
    <div className={className}>
      <Button type="primary" onClick={() => push(`/admin/announcements/add`)}>
        {t('announcements.add')}
      </Button>
    </div>
  );
}

